<template>
  <div>
    <q-btn-dropdown
      v-if="parentId"
      menu-anchor="bottom left"
      menu-self="top left"
      :title="label"
      class="full-height"
      v-bind="$attrs"
      flat
      no-caps
    >
      <template v-slot:label>
        <div class="flex items-center">
          <q-icon name="fa fa-users" class="on-left" />
          <div class="text-left" style="line-height: 1.2">
            <div class="ellipsis">{{ label }}</div>
            <div v-if="account">
              <small class="text-primary text-uppercase">
                <account-type :value="account.type" />
              </small>
            </div>
          </div>
        </div>
      </template>
      <accounts-dropdown
        v-if="parent && account"
        :parent="parent"
        :account="account"
        @update:account="$emit('update:account', $event)"
      />
    </q-btn-dropdown>
    <div v-else class="flex items-center full-height q-px-sm">
      <q-icon name="fa fa-users" class="on-left" />
      <strong class="ellipsis">{{ label }}</strong>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../styles/quasar.variables';

.ellipsis {
  max-width: 5rem;
  @media screen and (min-width: $breakpoint-sm-min) {
    max-width: 10rem;
  }
  @media screen and (min-width: $breakpoint-md-min) {
    max-width: 20rem;
  }
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Account } from '../types';
import AccountsDropdown from './AccountsDropdown.vue';
import accountRepository from './account-repository';
import AccountType from './AccountType.vue';

interface Data {
  parent: Account|null
}

export default defineComponent({
  emits: ['update:account'],
  components: {
    AccountType,
    AccountsDropdown,
  },
  props: {
    parentId: Number,
    account: Object as () => Account,
  },
  data(): Data {
    return {
      parent: null,
    };
  },
  computed: {
    label(): string|undefined {
      return this.account ? this.account.name : undefined;
    },
  },
  watch: {
    parentId: {
      async handler(parentId: number|undefined) {
        if (!parentId) return;
        this.parent = await accountRepository.find(parentId);
        if (!this.account) {
          this.$emit('update:account', this.parent);
        }
      },
      immediate: true,
    },
  },
});
</script>
